export const name = 'en_us';
export const dictionary = {
    // GENERAL
    GEN_BACK: 'Back',
    GEN_CLOSE: 'Close',
    GEN_LABEL_USER_ROLE_REGULAR: 'Regular User',
    GEN_LABEL_USER_ROLE_ADMIN: 'Admin',
    GEN_LABEL_USER_ROLE_BUSINES_OWNER: 'Business Owner',
    GEN_LABEL_EMAIL_ADDRESS: 'Email Address',
    GEN_LABEL_FULL_NAME: 'Full Name',
    GEN_LABEL_STATUS: 'Status',
    GEN_LABEL_ACCESS_TYPE: 'Access Type',
    GEN_LABEL_SENT_AT: 'Sent At',
    GEN_LABEL_PENDING: 'pending',
    GEN_LABEL_VIEW: 'View',
    GEN_LABEL_EMPTY: 'Empty',
    GEN_LABEL_COMING_SOON: 'Coming soon',
    GEN_LABEL_SUBMIT: 'Submit',
    GEN_LABEL_FIRST_NAME: 'First name',
    GEN_LABEL_LAST_NAME: 'Last name',
    GEN_LABEL_PHONE: 'Phone number',
    FORM_REQUIRED_FIELDS: 'Required field',
    GEN_DOWNLOAD: 'Download',
    // FOLDER
    FOLDER_ACCOUNTING: 'Accounting',
    FOLDER_AR: 'Accounts Receivable',
    FOLDER_PAYROLL: 'Payroll',
    FOLDER_TAX: 'Tax Return Documents',
    FOLDER_QUICKBOOKS_FILE: 'Quickbooks File',
    // BUCKET
    BUCKET_TAX_DOCUMENT: 'Tax Documents',
    BUCKET_LEGAL_DOCUMENT: 'Legal Documents',
    BUCKET_ACCOUNTING_DOCUMENT: 'Accounting Documents',
    // LABEL
    LABEL_DRAG_N_DROP_FILES: 'drag and drop files or click here',
    // ALERT
    ALERT_CONTACT_EMPLOYEE:
        'For security reasons, you cannot invite a Business Owner. Please contact us to add a Business Owner.',
    ALERT_CANNOT_RESEND_INVITE: "Invitation couldn't be resent",
    ALERT_CANNOT_CANCEL_INVITE: "Invitation couldn't be canceled",
    // MENU
    MENU_HOME: 'Home',
    MENU_FFDA_DASHBOARD: 'Dashboard',
    MENU_FFDA_SALES_ACTIVITY: 'Sales Activity',
    MENU_FFDA_REPORT: 'Reports',
    MENU_DOCUMENTS: 'Drive',
    MENU_DOCUMENTS_UPLOAD: 'Upload Center',
    MENU_SETTINGS: 'Settings',
    MENU_BILLING: 'Billing',
    MENU_ENTITY_FOLDER: 'Documents',

    // Top Bar
    TOP_BAR_MY_ACCOUNT: 'My Account',
    TOP_BAR_MY_SWITCH_ACCOUNT: 'Switch business',
    TOP_BAR_MY_LOG_OUT: 'Log out',
    // Switch Account Modal
    SWCH_ACC_MDL_LABEL_TITLE: 'Select contract',
    SWCH_ACC_MDL_OTHER_CONTRACT: 'Access other contracts on',
    // Homepage
    HOMEPAGE_TITLE_HOME: 'Home',
    HOMEPAGE_LABEL_WELCOME: 'Welcome!',
    HOMEPAGE_LABEL_ACCOUNT_SETUP: 'Account Setup',
    HOMEPAGE_LABEL_DOCUMENTS: 'Documents',
    HOMEPAGE_LABEL_DOCUMENTS_RECENT_TEXT: 'Recent activities',
    HOMEPAGE_LABEL_TASK_ADD_USER: 'Invite users',
    HOMEPAGE_LABEL_TASK_SECURE_MFA: 'Secure my account with 2FA',
    // Homepage - FFDA
    HOMEPAGE_TITLE_PROMO_HEADLINE: 'Federated Signature',
    HOMEPAGE_TITLE_PROMO_STATS_BOOKS: 'Stats Book',
    HOMEPAGE_TITLE_PROMO_SALARY_SURVEY: 'Salary Survey',
    // DASHBOARD
    DASHBOARD_TITLE: 'Dashboard',
    // SUPPLIES
    SUPPLIES_TITLE: 'Supplies',
    // REPORTS
    REPORTS_SALES_ACTIVITY_TITLE: 'Sales Activity',
    REPORTS_EXPORTS_TITLE: 'Generate Reports',
    REPORTS_SALES_ACTIVITY_DESC: 'Consult your sales activity',
    REPORTS_EXPORTS_DESC: 'Generate and export your reports',
    // DRIVE
    DRIVE_FEXPLORER_TITLE_HOMEPAGE: 'Documents',
    DRIVE_FEXPLORER_TITLE_UPLOAD_CENTER: 'Upload Center',
    DRIVE_FEXPLORER_TITLE_SEARCH_FILE: 'File search',
    DRIVE_FEXPLORER_TITLE_FILE_EXPLORER: 'File Explorer',
    DRIVE_FEXPLORER_TITLE_DETAILS: 'Details',
    DRIVE_FEXPLORER_TITLE_PREVIEW: 'Preview',
    DRIVE_FEXPLORER_FILE_NAME: 'File name',
    DRIVE_FEXPLORER_FILE_SIZE: 'File size',
    DRIVE_FEXPLORER_FILE_STATUS: 'Status',
    DRIVE_FEXPLORER_FILE_UPLOADED_AT: 'Uploaded at',
    DRIVE_FEXPLORER_FILE_LAST_UPDATE: 'Last update',
    DRIVE_FEXPLORER_EXTENSION: 'Extension',
    DRIVE_FEXPLORER_LAST_ACTIVITY: 'Last Activity',
    DRIVE_FEXPLORER_NOTHING_TO_SHOW: 'Nothing to show',
    DRIVE_FEXPLORER_CANNOT_PREVIEW: 'Cannot preview this type of document',
    DRIVE_UPLOAD_SLCT_INBX: 'Select inbox folder',
    DRIVE_UPLOAD_SLCT_CATEGORY: 'Select a year',
    DRIVE_UPLOAD_SLCT_BUCKET: 'Select document type',
    DRIVE_DETAILS_LABEL: 'Details',
    DRIVE_DETAILS_COMMENTS: 'Comments',
    DRIVE_DETAILS_INFORMATION: 'Information',
    DRIVE_DETAILS_LABEL_MESSAGE: 'Message',
    DRIVE_DETAILS_LABEL_EMPTY_DISCUSSION: 'No comment',
    // SETTINGS
    SETTINGS_PAGE_SETTINGS: 'Settings',
    SETTINGS_PAGE_SETTINGS_PROFILE: 'Settings - Profile',
    SETTINGS_PAGE_SETTINGS_SECURITY: 'Settings - Security',
    SETTINGS_PAGE_SETTINGS_ACCESS_MANAGEMENT: 'Settings - Access Management',
    SETTINGS_PAGE_SETTINGS_BILLING: 'Settings - Billing',
    SETTINGS_LABEL_LANGUAGE: 'Language',
    SETTINGS_LABEL_PROFILE: 'Profile',
    SETTINGS_LABEL_PROFILE_DESC:
        'Update your profile information and preferences.',
    SETTINGS_LABEL_PREFERENCES: 'Preferences',
    SETTINGS_LABEL_SECURITY: 'Security',
    SETTINGS_LABEL_SECURITY_DESC: 'Manage the security of your account here.',
    SETTINGS_LABEL_ACCESS_MANAGEMENT: 'Access Management',
    SETTINGS_LABEL_ACCESS_MANAGEMENT_DESC: "Invite and manage user's access.",
    SETTINGS_LABEL_UPLOAD_LIST: 'Upload list',
    SETTINGS_LABEL_UPLOAD_LIST_EMPTY: 'No file to upload',
    SETTINGS_LABEL_UPLOAD_WILL_BE_UPLOADED: 'Will be uploaded to',
    SETTINGS_LABEL_AUTO_UPLOAD: 'Auto-Upload',
    SETTINGS_LABEL_FILE_UPLOADED: 'File Uploaded',
    SETTINGS_LABEL_FILE_UPLOAD_FAILED: 'File upload failed',
    SETTINGS_LABEL_FILE_SIZE_LIMIT: 'File size limit',
    SETTINGS_LABEL_BILLING: 'Billing',
    SETTINGS_LABEL_BILLING_DESC:
        'Manage your payment method and access your billing history',
    // Errors file upload
    UPLOAD_FILE_ERROR_LIMIT_EXCEEDED: 'File size limit exceeded',
    UPLOAD_FILE_ERROR_UNKNOWN:
        "Couldn't upload the file, please try again later. If the problem persists, contact the support.",
    // Settings: Security
    SETTINGS_P_SEC_CARD_2FA_SETUP: 'Two factor authentication (2FA)',
    // Settings: Access Management
    SETTINGS_LABEL_INVITE_USER: 'Invite',
    SETTINGS_LABEL_CONFIRM_USER_INVITE_REMOVAL:
        'Confirm cancellation of the invitation',
    SETTINGS_LABEL_CONFIRM_USER_INVITE_RESEND: 'Confirm resend invitation',
    SETTINGS_LABEL_BTN_RESEND_INVITE: 'Resend',
    SETTINGS_LABEL_BTN_CANCEL_INVITE: 'Cancel Invite',
    SETTINGS_LABEL_TAB_ALL: 'All',
    SETTINGS_LABEL_TAB_ACTIVE: 'Active',
    SETTINGS_LABEL_TAB_INACTIVE: 'Inactive',
    SETTINGS_LABEL_TAB_PENDING_IVTS: 'Pending Invites',
    SETTINGS_LABEL_NO_PDN_IVT: 'No pending invite',
    SETTINGS_ACCESS_INFO_UPDATE_EMAIL_EXISTS:
        'An email update request with the following address is awaiting validation by an employee',
    SETTINGS_ACCESS_INFO_UPDATE_EMAIL_UPDATED: 'Email successfully updated.',
    SETTINGS_ACCESS_INFO_UPDATE_EMAIL_SENT:
        'Email address change request sent successfully, an email has been sent to you to confirm your request.',
    // Settings: Access Management - Invite Modal
    SETTINGS_INV_MDL_TITLE: 'Invite someone',
    SETTINGS_INV_MDL_BTN_SEND: 'Send invite',
    SETTINGS_INV_MDL_BTN_SENDING: 'Sending invite...',
    SETTINGS_INV_MDL_INV_SENT: 'Invitation sent!',
    SETTINGS_INV_MDL_INV_OOPS: 'Something went wrong, please retry.',
    SETTINGS_INV_MDL_INV_EXISTS:
        'An invitation has already been sent to this user.',
    // Settings: Billing - Homepage
    BILLING_PAY_NOW: 'Pay now',
    SETTINGS_BILLG_LABEL_LAST_PAYMENT: 'Last payment',
    SETTINGS_BILLG_LABEL_CURRENT_BILL: 'Current bill',
    SETTINGS_BILLG_LABEL_RETAINER: 'Credit on account',
    SETTINGS_BILLG_LABEL_BALANCE: 'Balance',
    SETTINGS_BILLG_LABEL_PAY_BALANCE_TITLE: 'Estimated remaining due',
    SETTINGS_BILLG_LABEL_PAY_BALANCE_TOOLTIP:
        'This is a live estimation of the balance due before posting',
    // Cookie - Authorization
    PROMPT_AUTHRZ_COOKIE_TITLE: 'We use cookies',
    PROMPT_AUTHRZ_COOKIE_TEXT:
        'We use cookies and other tracking technologies to improve your browsing experience on our website, to analyze our website traffic, and to understand where our visitors are coming from.',
    PROMPT_AUTHRZ_COOKIE_BTN_AGREE: 'I agree',
    PROMPT_AUTHRZ_COOKIE_BTN_DECLINE: 'I decline',
    // Authentication - Login
    LOGIN_FAILED_WAITING_PERMISSION:
        'Cannot log in, your permission must be set by a business owner',
};

export default {
    name,
    dictionary,
};
